<template>
	<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" viewBox="0 0 20 20">
		<defs>
			<clipPath id="clip-path-bloggg">
				<rect
					id="Rectangle_15502"
					data-name="Rectangle 15502"
					width="20"
					height="20"
					transform="translate(429 795)"
					fill="#fff"
					stroke="#707070"
					stroke-width="1"
				/>
			</clipPath>
		</defs>
		<g id="Mask_Group_44953" data-name="Mask Group 44953" transform="translate(-429 -795)" clip-path="url(#clip-path-bloggg)">
			<g id="Layer_1-2" transform="translate(429 795)">
				<circle id="Ellipse_932" data-name="Ellipse 932" cx="10" cy="10" r="10" fill="#fff" />
				<circle id="Ellipse_933" data-name="Ellipse 933" cx="10" cy="10" r="10" fill="#969bae" />
				<g id="Group_45879">
					<path
						id="Path_32982"
						d="M5.03,4.32A1.182,1.182,0,0,0,3.85,5.5v8.28a1.9,1.9,0,0,0,1.89,1.89H15.2a1.9,1.9,0,0,1-1.89-1.89V5.51a1.182,1.182,0,0,0-1.18-1.18H5.04ZM10,8.58a.47.47,0,0,0,0,.94h.95a.47.47,0,1,0,0-.94ZM9.53,7.16A.469.469,0,0,1,10,6.69h.95a.47.47,0,1,1,0,.94H10A.469.469,0,0,1,9.53,7.16ZM6.22,10.47a.47.47,0,0,0,0,.94h4.73a.47.47,0,1,0,0-.94Zm-.47,2.36a.469.469,0,0,1,.47-.47h4.73a.47.47,0,0,1,0,.94H6.22A.469.469,0,0,1,5.75,12.83Zm.47-6.15a.469.469,0,0,0-.47.47V9.04a.469.469,0,0,0,.47.47H8.11a.469.469,0,0,0,.47-.47V7.15a.469.469,0,0,0-.47-.47H6.22Z"
						fill="#fff"
						fill-rule="evenodd"
					/>
					<path id="Path_32983" d="M14.26,6.69h1.18a.713.713,0,0,1,.71.71v6.38a.95.95,0,0,1-1.9,0V6.69Z" fill="#fff" />
				</g>
			</g>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'BlogPostSvg',
};
</script>
